import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Wheel } from 'react-custom-roulette';
import confetti from 'canvas-confetti';
import "../ScrollReveal.css";
import { collection, query, where, getDocs, addDoc, Timestamp } from 'firebase/firestore';
import { userDb } from '../firebaseUsers';

const SpinningWheelGame = () => {
  const [userList, setUserList] = useState([]);
  const [winner, setWinner] = useState(null);
  const [hasSpun, setHasSpun] = useState(false);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [login, setLogin] = useState(null);
  const navigate = useNavigate();

  const now = new Date();
  const previousMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
  const yearOfPreviousMonth = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
  const prize = "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925237/my_uploads/qy3iujd2mdeh5bpycvow.jpg";

  // Get logged-in user from localStorage
  useEffect(() => {
    const storedEmail = localStorage.getItem("userEmail");
    if (storedEmail) {
      setLogin({ email: storedEmail.trim().toLowerCase() });
      // console.log("Logged-in user email:", storedEmail);
    }
  }, []);

  useEffect(() => {
    const fetchUsersAndWinner = async () => {
      try {
        // console.log("Fetching winner for month", previousMonth + 1, "year", yearOfPreviousMonth);

        // Check if winner exists
        const winnersRef = collection(userDb, 'winners');
        const winnerQuery = query(
          winnersRef,
          where('month', '==', previousMonth),
          where('year', '==', yearOfPreviousMonth)
        );
        const winnerSnapshot = await getDocs(winnerQuery);

        if (!winnerSnapshot.empty) {
          const data = winnerSnapshot.docs[0].data();
          // console.log("Winner found in Firestore:", data);
          setWinner({ name: data.name, email: data.email.trim().toLowerCase() });
          setHasSpun(true);
        } else {
          console.log("No winner yet for this month/year.");
        }

        // Fetch all users
        // console.log("Fetching all users...");
        const usersRef = collection(userDb, 'users');
        const usersSnapshot = await getDocs(usersRef);
        const usersArray = usersSnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            option: data.username,
            email: data.email.trim().toLowerCase(),
            id: doc.id,
            raw: data,
          };
        });
        // console.log("Users fetched:", usersArray.map(u => u.email));
        setUserList(usersArray);

      } catch (error) {
        console.error("Error fetching users or winner:", error);
      }
    };

    fetchUsersAndWinner();
  }, [previousMonth, yearOfPreviousMonth]);

  const claim = () => {
    navigate("/claim");
  };

  const handleSpinClick = () => {
    if (userList.length === 0 || hasSpun) return;
    const randomIndex = Math.floor(Math.random() * userList.length);
    // console.log("Spinning wheel... random index:", randomIndex);
    setPrizeNumber(randomIndex);
    setMustSpin(true);
  };

  const onStopSpinning = async () => {
    setMustSpin(false);
    const selectedUser = userList[prizeNumber];
    console.log("Selected winner:", selectedUser);

    const winnerData = {
      name: selectedUser.option,
      email: selectedUser.email.trim().toLowerCase(),
    };
    setWinner(winnerData);
    setHasSpun(true);

    confetti({ particleCount: 200, spread: 100, origin: { y: 0.6 } });

    try {
      await addDoc(collection(userDb, 'winners'), {
        name: selectedUser.option,
        email: selectedUser.email,
        month: previousMonth,
        year: yearOfPreviousMonth,
        createdAt: Timestamp.now(),
      });
      // console.log("Winner saved to Firestore:", winnerData);
    } catch (error) {
      console.error("Error saving winner:", error);
    }
  };

  // Debug logs
  // console.log("Current login:", login);
  // console.log("Current winner:", winner);

  return (
    <div style={{ textAlign: 'center', marginTop: 50, padding: 30, borderRadius: 20, background: 'linear-gradient(to right, #ffecd2, #fcb69f)', boxShadow: '0 0 40px rgba(0, 0, 0, 0.2)', maxWidth: 600, margin: '50px auto' }}>
      <h2 style={{ fontSize: '2.5rem', color: '#333', fontWeight: 'bold', animation: 'fadeInDown 1s ease-in-out', marginBottom: 20 }}>🎡 Monthly Prize Wheel</h2>

      {userList.length > 0 && !hasSpun && (
        <button
          onClick={handleSpinClick}
          style={{ padding: '12px 28px', fontSize: '20px', background: 'linear-gradient(to right, #00b09b, #96c93d)', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer', boxShadow: '0 6px 20px rgba(0,0,0,0.1)', transition: 'transform 0.2s ease-in-out', marginBottom: 30 }}
        >
          🎯 Spin Now!
        </button>
      )}

      {hasSpun && winner && (
        <>
          {login && login.email === winner.email ? (
            <>
              <h3 style={{ color: '#d63384', fontSize: '2rem', marginTop: 30, textShadow: '0 0 10px #fbc2eb', animation: 'popIn 1s ease-out', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                🏆 Congratulations {winner.name}!
                <p style={{ marginTop: 10 }}>You are the winner of the month 🎉</p>
                <img src={prize} alt="Prize" className="prize-image" />
              </h3>
              <button data-label="Register" className="rainbow-hover" onClick={claim}>
                <span className="sp">Claim your Prize</span>
              </button>
            </>
          ) : (
            <h3 style={{ color: '#555', fontSize: '1.5rem', marginTop: 30, fontStyle: 'italic' }}>
              😢 Sorry, you are not the winner this time. Try again next month!
            </h3>
          )}
        </>
      )}

      {userList.length > 0 && !hasSpun && (
      // || (winner && login && login.email === winner.email)) && (
        <div className="wheel" style={{ maxWidth: 400, marginTop: 25 }}>
          <Wheel
            mustStartSpinning={mustSpin}
            prizeNumber={prizeNumber}
            data={userList}
            backgroundColors={['#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1']}
            textColors={['black']}
            fontSize={12}
            outerBorderColor={'#ffffff'}
            outerBorderWidth={6}
            innerBorderColor={'#cccccc'}
            radiusLineColor={'#eeeeee'}
            radiusLineWidth={3}
            onStopSpinning={onStopSpinning}
            spinDuration={0.09}
          />
        </div>
      )}

      <style>{`
        @keyframes fadeInDown { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes popIn { 0% { transform: scale(0.6); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
      `}</style>
    </div>
  );
};

export default SpinningWheelGame;
